<template>
  <div class="switch-group">
    <slot name="label">
      <label v-if="label" class="control-label">
        {{label}}
      </label>
      <img v-if="tooltip" v-tooltip="{ content: tooltip, offset: 0}" style="postion:absolute;" src="@/assets/static/img/tooltip/tooltip.svg" alt="..."/>
    </slot>
    <div class="switch-container" :class="{ 'tooltip-alignment': tooltip } ">
      <label class="switch" v-bind="$attrs">
        <input type="checkbox"
               :checked="value"
               v-bind="$attrs"
               @change="$emit('input', $event.target.checked)">
        <span class="slider round"></span>
      </label>
    </div>
  </div>
</template>

<script>
  export default{
    name: "switch-group",
    props: {
      label: String,
      tooltip: String,
      value: Boolean,
    },
  }
</script>